import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from '_containers/App';
import ConnectedIntlProvider from '__common/providers/ConnectedIntlProvider';
import ThemeProvider from '../../theme/ThemeProvider';

const Root: React.StatelessComponent<onlyStoreComponentState> = ({ store }) => (
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider>
        <ConnectedIntlProvider>
          <App />
        </ConnectedIntlProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);

export default Root;
